import React from "react";
import "../../assets/styles/components.css";
import { Stages } from "../../actions/actions";

export default class Breadcrumbs extends React.Component {
  render() {
    let initStyle = "";

    let currentStage = this.props.stage;
    let container = "";
    switch (this.props.provider) {
      case "default":
        container = "cal container__Header";
        break;
      case "bit":
        container = "bit container__Header";
        break;
      case "leumi":
        container = "leumi container__Header";
        break;
    }

    let stage = "";
    let srStage = "";
    switch (currentStage) {
      case Stages.login:
        stage = "progress-bar-heavy__Header stage1";
        srStage = "שלב 1 מתוך 3 - הזדהות";
        break;
      case Stages.cards:
        stage = "progress-bar-heavy__Header stage2";
        srStage = "שלב 2 מתוך 3 - בחירת כרטיס";
        break;
      case Stages.pin:
        stage = "progress-bar-heavy__Header stage3";
        srStage = "שלב 3 מתוך 3 - קוד סודי";
        break;
    }
    return (
      <div className={container}>
        <div className="progress-bar__Header">
          <div className={stage}></div>
        </div>
      </div>

      /* <div className={wrapClass}>
        <div className={stage1active}></div>
        <div className={stage2active}></div>
        <div className={stage3active}></div>
      </div>*/
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/Breadcrumbs.jsx